import { SelectFields } from '@repo/toolkit/types'

import {
  EnrollmentIdentity,
  EnrollmentIdentityInput
} from '../../lib/types/models/enrollment/enrollment-identity'
import { FieldsSelector, UpdateInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function submitEnrollmentIdentityForUSA<T extends FieldsSelector<EnrollmentIdentity>>(
  data: UpdateInput<EnrollmentIdentityInput>,
  fields: T
) {
  const { id, ...rest } = data

  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.submitEnrollmentIdentityForUSA.url, { id }),
        { fields }
      )
    )
    .post<SelectFields<EnrollmentIdentity, T>, EnrollmentIdentityInput>(rest)
}
